import { axios } from 'services/axios';

export const getPlatformUsers = async (companyId, platformId, scope) => {
    const response = await axios.get(
        `/PlatformUsers/${companyId}/platform/${platformId}`,
        { headers: { 'X-RequestScope': scope } },
    );
    return {
        status: 200,
        data: Array.isArray(response.data) ? response.data : [],
    };
};

export const getPlatformUserById = async (userId, companyId, scope) => {
    const response = await axios.get(
        `/PlatformUsers/${companyId}/TcapUser/${userId}`,
        { headers: { 'X-RequestScope': scope } },
    );
    return { status: 200, data: response.data };
};

export const createPlatformUser = async (payload, scope) => {
    const response = await axios.post('/PlatformUser', payload, {
        headers: { 'X-RequestScope': scope },
    });
    return { status: 201, data: response.data };
};

export const updatePlatformUser = async (payload, scope) => {
    const response = await axios.put('/PlatformUser', payload, {
        headers: { 'X-RequestScope': scope },
    });
    return { status: 200, data: response.data };
};

export const deletePlatformUser = async (userId, scope) => {
    const response = await axios.delete(`/PlatformUser/${userId}`, {
        headers: { 'X-RequestScope': scope },
    });
    return { status: 200, data: response.data };
};

export const reactivatePlatformUser = async (userId, scope) => {
    const response = await axios.post(
        `/PlatformUser/${userId}/Reactivate`,
        {},
        { headers: { 'X-RequestScope': scope } },
    );
    return { status: 200, data: response.data };
};

export const getSites = async (serviceId, scope) => {
    const response = await axios.get(`/Sites/${serviceId}`, {
        headers: { 'X-RequestScope': scope },
    });
    return {
        status: 200,
        data: Array.isArray(response.data) ? response.data : [],
    };
};

export const getLicenses = async (serviceId, scope) => {
    const response = await axios.get(
        `/Service/EightByEight/${serviceId}/Licenses`,
        { headers: { 'X-RequestScope': scope } },
    );
    return {
        status: 200,
        data: Array.isArray(response.data) ? response.data : [],
    };
};

export const getAvailableNumbers = async (companyId, scope) => {
    const response = await axios.get(
        `/company/${companyId}/numbers/available`,
        {
            headers: { 'X-RequestScope': scope },
        },
    );
    return {
        status: 200,
        data: Array.isArray(response.data) ? response.data : [],
    };
};

export const getUserProfile = async (platformUserId, scope) => {
    const response = await axios.get(`/UserProfiles/${platformUserId}`, {
        headers: { 'X-RequestScope': scope },
    });
    return { status: 200, data: response.data };
};

export const deleteUserProfile = async (
    numberID,
    platformId,
    platformUserId,
    scope,
) => {
    const response = await axios.delete(
        `/UserProfile?NumberID=${numberID}&PlatformID=${platformId}&PlatformUserID=${platformUserId}`,
        { headers: { 'X-RequestScope': scope } },
    );
    return { status: 200, data: response.data };
};

export const createUserProfile = async (payload, scope) => {
    const response = await axios.post('/UserProfile', payload, {
        headers: { 'X-RequestScope': scope },
    });
    return { status: 201, data: response.data };
};

export const updateUserProfile = async (payload, scope) => {
    const response = await axios.put('/UserProfile', payload, {
        headers: { 'X-RequestScope': scope },
    });
    return { status: 200, data: response.data };
};

export const getExtendedAttributes = async (platformID, userTypeID, scope) => {
    const response = await axios.get(
        `/PlatformUsers/ExtendedAttributes/${platformID}/${userTypeID}`,
        { headers: { 'X-RequestScope': scope } },
    );
    return {
        status: 200,
        data: Array.isArray(response.data) ? response.data : [],
    };
};

export const getRingGroupMembers = async (ringGroupID, scope) => {
    const response = await axios.get(
        `/PlatformUser/RingGroup/Membership/${ringGroupID}`,
        { headers: { 'X-RequestScope': scope } },
    );
    return {
        status: 200,
        data: Array.isArray(response.data) ? response.data : [],
    };
};

export const getRingGroupMember = async (ringGroupID, memberID, scope) => {
    const response = await axios.get(
        `/PlatformUser/RingGroup/Membership/${ringGroupID}/${memberID}`,
        { headers: { 'X-RequestScope': scope } },
    );
    return { status: 200, data: response.data };
};

export const createRingGroupMembership = async (payload, scope) => {
    const response = await axios.post(
        '/PlatformUser/RingGroup/Membership',
        payload,
        { headers: { 'X-RequestScope': scope } },
    );
    return { status: 201, data: response.data };
};

export const updateRingGroupMembership = async (payload, scope) => {
    const response = await axios.put(
        '/PlatformUser/RingGroup/Membership',
        payload,
        { headers: { 'X-RequestScope': scope } },
    );
    return { status: 200, data: response.data };
};

export const deleteRingGroupMembership = async (payload, scope) => {
    const response = await axios.delete('/PlatformUser/RingGroup/Membership', {
        data: payload,
        headers: { 'X-RequestScope': scope },
    });
    return { status: 200, data: response.data };
};
